import React, { Component } from 'react';
import './App.css';
import Layout from '../../hoc/Layout/Layout.jsx';
import { Route, Switch, Redirect } from 'react-router-dom';
import BurgerBuilder from '../BurgerBuilder/BurgerBuilder.jsx';
import Logout from '../Logout/Logout';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actions/index';
// import asyncComponent from '../../hoc/asyncComponent/asyncComponent';

import Checkout from '../Checkout/Checkout';
import Orders from '../Orders/Orders';
import Auth from '../Auth/Auth';
import PageNotFound from '../../components/miscUtility/PageNotFound/PageNotFound';

// const asyncCheckout = asyncComponent(() => {
//   return import('../Checkout/Checkout')
// })
// const asyncOrders = asyncComponent(() => {
//   return import('../Orders/Orders')
// })
// const asyncAuth = asyncComponent(() => {
//   return import('../Auth/Auth')
// })
// const asyncPageNotFound = asyncComponent(() => {
//   return import('../../components/miscUtility/PageNotFound/PageNotFound')
// })

const userData = () => {
  let userDataFromStorage = {
    emailFromStorage: null,
    userIdFromStorage: null,
    tokenFromStorage: null
  }
  if (localStorage.getItem('userData') !== null) {
    userDataFromStorage = JSON.parse(localStorage.getItem('userData'));
  }
  return {
    emailFromStorage: userDataFromStorage.email,
    userIdFromStorage: userDataFromStorage.userId,
    tokenFromStorage: userDataFromStorage.token
  }
}



class App extends Component {
  componentDidMount() {
    const expirationDate = new Date(localStorage.getItem('expirationDate'));
    const currentTime = new Date()
    const expired = currentTime >= expirationDate;
    if (userData().tokenFromStorage && !expired) {
      this.props.SetUserData(userData().tokenFromStorage, userData().userIdFromStorage, userData().emailFromStorage);
      this.props.CheckAuthTimeout();
    } else {
      this.props.Logout();
    }
  }
  render() {

    return (
      <Layout >
        <Switch>
          <Redirect from='/' exact to='/build' />
          <Route path='/orders' component={Orders} />
          <Route path='/checkout' component={Checkout} />
          <Route path='/authenticate' component={Auth} />
          <Route path='/logout' component={Logout} />
          <Route path='/build' component={BurgerBuilder} />
          <Route path='/page_not_found' component={PageNotFound} />
          <Redirect to='/page_not_found' />
        </Switch>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetUserData: (token, userId, email) => dispatch(actionCreators.setUserData(token, userId, email)),
    CheckAuthTimeout: () => dispatch(actionCreators.checkAuthTimeout()),
    Logout: () => dispatch(actionCreators.logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx